import { SmartusComponentsModule } from '@affinis/smartus-components';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MtxGridModule } from '@ng-matero/extensions/grid';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

import { MatIconModule } from '@angular/material/icon';
import { SalesClient } from '@core/api';
import { OverrideModule } from '@mandants/telekom/override/override.module';
import { HtmlEditorComponent } from '@shared/components/html-editor/html-editor.component';
import { SafeHtmlPipe } from '@shared/pipes';
import { SalesListingEditComponent } from '../website-edit-sell/sales-listing-edit';
import { ConfirmationDialogComponent } from './components/rental-listing-edit-dialog/confirmation-dialog.component';
import { RentalListingEditComponent } from './components/rental-listing-edit/rental-listing-edit.component';
import { WebsiteEditComponent } from './website-edit.component';

const components = [
  WebsiteEditComponent,
  RentalListingEditComponent,
  ConfirmationDialogComponent,
  SalesListingEditComponent,
];
@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    SmartusComponentsModule,
    TranslateModule,
    FormlyModule,
    MtxGridModule,
    AngularEditorModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatOptionModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    OverrideModule,
    SafeHtmlPipe,
    HtmlEditorComponent,
    MatIconModule,
  ],
  exports: [...components],
  providers: [SalesClient],
})
export class WebsiteEditModule {}
